import { detectLocale, initI18n } from '@qalam/shared/frontend';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';

// Browser language first, Arabic as the fallback. Initialised before the first
// render so no donor ever sees a frame of the wrong language.
initI18n(detectLocale());

const container = document.getElementById('root');
if (!container) {
  throw new Error('root element is missing from index.html');
}

// The session provider lives inside the app shell (`App.tsx`), not here: the
// 3-D Secure result page is a route of this same app and must render without
// ever touching a session.
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
